module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAGBAMAAADwPukCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA9QTFRF+Pj47+/v5ubm3d3d/////QfgkwAAABJJREFUCB1jMGDmYGYAAgcmBgADXgCBoYSa8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/jquery.uniform/dist/images/default/bg-input-focus.png
// module id = ../../../../jquery.uniform/dist/images/default/bg-input-focus.png
// module chunks = styles